// App Context constants
export const CHANGE_VELOCITY_LAYER_TIMING = 'CHANGE_VELOCITY_LAYER_TIMING';
export const CHANGE_LICENCE_AREA_SELECTED = 'CHANGE_LICENCE_AREA_SELECTED';
export const CHANGE_LAYER_SELECTED = 'CHANGE_LAYER_SELECTED';
export const CHANGE_WIND_PARTICULES_SELECTED =
  'CHANGE_WIND_PARTICULES_SELECTED';
export const CHANGE_EVENT_WIND_PARTICULES_SELECTED =
  'CHANGE_EVENT_WIND_PARTICULES_SELECTED';
export const CHANGE_GRID_LAYER_SELECTED = 'CHANGE_GRID_LAYER_SELECTED';
export const CHANGE_EVENT_GRID_LAYER_SELECTED =
  'CHANGE_EVENT_GRID_LAYER_SELECTED';
export const CHANGE_EVENT_LICENCE_AREA_SELECTED =
  'CHANGE_EVENT_LICENCE_AREA_SELECTED';
export const CHANGE_EVENT_LAYER_SELECTED = 'CHANGE_EVENT_LAYER_SELECTED';
export const CHANGE_START_DATE = 'CHANGE_START_DATE';
export const CHANGE_CURRENT_TIME = 'CHANGE_CURRENT_TIME';
export const CHANGE_STARTING_TIME = 'CHANGE_STARTING_TIME';
export const CHANGE_CURRENT_TIME_COMPARISON = 'CHANGE_CURRENT_TIME_COMPARISON';
export const CHANGE_TIMELINE_PLAYING = 'CHANGE_TIMELINE_PLAYING';

export const CHANGE_WEATHER_HORODATETIME = 'CHANGE_WEATHER_HORODATETIME';
export const CHANGE_MARKER_COORDINATES = 'CHANGE_MARKER_COORDINATES';
export const CHANGE_EVENT_LIBRARY_PANEL = 'CHANGE_EVENT_LIBRARY_PANEL';
export const CHANGE_EVENT_LIBRARY_FILTERS = 'CHANGE_EVENT_LIBRARY_FILTERS';
export const CHANGE_TOTAL_KPI_LINE_CHART = 'CHANGE_TOTAL_KPI_LINE_CHART';
export const CHANGE_MODAL_IS_OPEN = 'CHANGE_MODAL_IS_OPEN';
export const CHANGE_EVENT_NAME = 'CHANGE_EVENT_NAME';
export const CHANGE_TIMELINE_MODE = 'CHANGE_TIMELINE_MODE';
export const CHANGE_SUBSTATIONS_SELECTED = 'CHANGE_SUBSTATIONS_SELECTED';
export const CHANGE_DISTRICT_SUBSTATIONS_SELECTED = 'CHANGE_DISTRICT_SUBSTATIONS_SELECTED';
export const CHANGE_EVENT_SUBSTATIONS_SELECTED = 'CHANGE_EVENT_SUBSTATIONS_SELECTED';
